<template>
    <div>

        <div>


            <v-form v-model="shareValid" ref="shareform" lazy-validation>
                <div>
                    <v-text-field
                            label="TO (coach name)"
                            v-model="to_name"
                            :rules="sharingRules"
                    ></v-text-field>
                </div>

                <div>
                    <v-text-field
                            label="School/Organization"
                            v-model="organization"
                            :rules="sharingRules"
                            required
                    ></v-text-field>
                </div>

                <div>
                    <v-text-field
                            label="Email (Coach Email)"
                            v-model="to_email"
                            :rules="sharingRules"
                    ></v-text-field>
                </div>

                <div>
                    <v-text-field
                            label="FROM (verified player email)"
                            v-model="from_email"
                            readonly
                    ></v-text-field>
                </div>

                <div>
                    <v-textarea
                            label="Message Body"
                            v-model="message"
                            :rules="sharingRules"
                            multi-line
                    ></v-textarea>
                </div>

                <div>
                    <v-btn  large flat  @click="share" class="shrbtn" >
                        Share <v-icon class="flip">reply</v-icon>
                    </v-btn>
                </div>
            </v-form>


        </div>

        <v-dialog v-model="dialog3" max-width="500px">
            <v-card>
                <v-card-title>
                    <h3><v-icon class="flip">reply</v-icon> Message sent!</h3>
                </v-card-title>
                <v-card-text>
                    Check your <h2>Metrix <v-btn outline fab :color="this.$store.state.club.color1"  class="bfab">
                                <v-icon>done_all</v-icon>
                               </v-btn>
                </h2>
                    to track email opens and views!
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" flat
                           @click.stop="dialog3=false">OK!</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



    </div>
</template>

<style scoped>
    .flip{
        transform: scaleX(-1);
    }
    .shrbtn{
        border: solid thin #555555;
    }
    .infobox {
        border: solid thin #555555;
        border-radius:3px;
        padding:3px;
        display: inline-block;
        width:100%;
        text-align: left;
        font-size: 1.4em;
    }
</style>

<script>
    export default{
        name:'Share',
        props:['player','color1'],
        data () {
            return {
                token:window.localStorage.getItem('a4ltoken'),
                to_name:'',
                organization:'',
                to_email:'',
                from_email:'',
                message:'',
                dialog3:false,
                shareValid:false,
                sharingRules: [
                    (v) => !!v || 'Required'
                ],
            }
        },
        components: {},
        mounted(){
            this.from_email = this.player.info.email
        },
        methods:{
            test(){
                this.$emit('closeshare');
            },
            share(){
                if (this.$refs.shareform.validate()) {
                    //todo these variables need to be refractered.. they aren't really clear... ("player"=>playerurl)
                    var data = {
                        token:this.token,
                        player: this.player.partkey,
                        toname:this.to_name,
                        toemail:this.to_email,
                        from:this.player.info.email,
                        body:this.message,
                        organization:this.organization,
                        fullname:this.player.info.firstname+' '+this.player.info.lastname,
                        club:this.$store.state.activeplayer.sport[this.$store.state.sport].club.partkey
                    };
                    var em = this;
                    // axios.post(this.$store.state.url+'api/share/sendemail', data)
                    //         .then(function(data){
                    //             console.log(data.data);
                    //             em.dialog3 = true;
                    //             em.to_name = '';
                    //             em.organization = '';
                    //             em.to_email = '';
                    //             em.message = '';
                    //             //shareValid:false,
                    //             em.shareValid = true;
                    //             em.$emit('closeshare');
                    //
                    //         }).catch(function(err){
                    //     console.log(err);
                    // });
                }
            }
        }
    }
</script>